import Input from '@returnmates/ui-core/src/components/Input'
import { PLSuccessPDefaultValues } from '@returnmates/ui-core/src/constants/PLSuccessPDefaultValues'
import { memo } from 'react'
import { Field } from 'react-final-form'

import useStyles from '../styles'

function SuccessSettings() {
  const classes = useStyles({})

  return (
    <>
      <div className={classes.detailsRow}>
        <p className={classes.inputHead}>Success header</p>
        <Field name="successHeaderDesktop">
          {({ input, meta }) => (
            <Input
              placeholder={PLSuccessPDefaultValues.successHeaderDesktop}
              classes={{
                textField: classes.input,
              }}
              onChange={input.onChange}
              value={input.value}
              fullWidth
              helperText={meta.error}
              error={meta.touched && meta.error}
            />
          )}
        </Field>
      </div>
      <div className={classes.detailsRow}>
        <p className={classes.inputHead}>Success subheader</p>
        <Field name="successSubHeaderDesktop">
          {({ input, meta }) => (
            <Input
              placeholder={PLSuccessPDefaultValues.successSubHeaderDesktop}
              classes={{
                textField: classes.input,
              }}
              onChange={input.onChange}
              value={input.value}
              fullWidth
              helperText={meta.error}
              error={meta.touched && meta.error}
            />
          )}
        </Field>
      </div>
      <div className={classes.detailsRow}>
        <p className={classes.inputHead}>Success header mobile</p>
        <Field name="successHeaderMobile">
          {({ input, meta }) => (
            <Input
              placeholder={PLSuccessPDefaultValues.successHeaderMobile}
              classes={{
                textField: classes.input,
              }}
              onChange={input.onChange}
              value={input.value}
              fullWidth
              helperText={meta.error}
              error={meta.touched && meta.error}
            />
          )}
        </Field>
      </div>
      <div className={classes.detailsRow}>
        <p className={classes.inputHead}>Success subheader mobile</p>
        <Field name="successSubHeaderMobile">
          {({ input, meta }) => (
            <Input
              placeholder={PLSuccessPDefaultValues.successSubHeaderMobile}
              classes={{
                textField: classes.input,
              }}
              onChange={input.onChange}
              value={input.value}
              fullWidth
              helperText={meta.error}
              error={meta.touched && meta.error}
            />
          )}
        </Field>
      </div>
      <div className={classes.detailsRow}>
        <p className={classes.inputHead}>Success button</p>
        <Field name="successButton">
          {({ input, meta }) => (
            <Input
              placeholder={PLSuccessPDefaultValues.successButton}
              classes={{
                textField: classes.input,
              }}
              onChange={input.onChange}
              value={input.value}
              fullWidth
              helperText={meta.error}
              error={meta.touched && meta.error}
            />
          )}
        </Field>
      </div>
      <div className={classes.detailsRow}>
        <p className={classes.inputHead}>Success Button Redirect</p>
        <Field name="plpSuccessRedirectUrl">
          {({ input, meta }) => (
            <Input
              placeholder="returnmates.com/trip/{tripid}"
              classes={{
                textField: classes.input,
              }}
              onChange={input.onChange}
              value={input.value}
              fullWidth
              helperText={meta.error}
              error={meta.touched && meta.error}
            />
          )}
        </Field>
      </div>
    </>
  )
}

export default memo(SuccessSettings)
